import type { GlossaryTopicSlug } from "@/lib/glossary-topics";

/**
 * 領域ごとの絵。コースの札 (/course-thumb) の既存の絵から、領域にいちばん近い 1 枚を当てる。
 * 新しく描かず、コースの札と同じ絵を使う。用語の札と、用語の共有の絵 (scripts/ogp-site) の両方がこの表を読む
 */
export const TOPIC_ART: Record<GlossaryTopicSlug, string> = {
  ai: "gene-ai-2026-10d",
  programming: "javascript-basics-2026-10d",
  web: "html-basics-2026-10e",
  frontend: "css-layout-2026-10d",
  backend: "go-web-api-2026-10c",
  database: "db-design-basics-2026-10d",
  infrastructure: "aws-saa-2026-10d",
  security: "authentication-authorization-security-2026-10c",
  "development-tools": "git-basics-2026-10c-v2",
  "it-basics": "cs-theory-2026-10d",
};
